export const isElementIdInViewport = (element: string): boolean => {
  const idElement = document.getElementById(element)
  if (idElement) {
    const rect = idElement.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }
  return false
}
